export { Bookmark as default } from './Bookmark';
